import { useEffect } from "react";
import { animationDuration } from "../../settings";
import { KeyboardEventKeys } from "../../typings/types";
import isNotEmpty from "../../utils/isNotEmpty";
import { getFocusableElementsInWrapper } from "../useFocusWrapper";
var useModalFocus = function useModalFocus(ref) {
  var elementWhichOpenedModal = typeof window !== "undefined" ? document.activeElement : null;
  useEffect(function () {
    setTimeout(function () {
      if (ref && ref.current) {
        var focusableElements = getFocusableElementsInWrapper(ref.current);
        if (focusableElements.length === 1) focusableElements[0].focus();
        if (focusableElements.length > 1) focusableElements[1].focus();
      }
    }, animationDuration["default"]);
  }, [ref]);
  var handleKeyDown = function handleKeyDown(event) {
    var focusableElements = getFocusableElementsInWrapper(ref === null || ref === void 0 ? void 0 : ref.current);
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    if (event.key === KeyboardEventKeys.TAB && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      var indexToFocus = event.shiftKey && focusableElements.length > 1 ? focusableElements.length - 2 : 0;
      focusableElements[indexToFocus].focus();
    }
    if (event.shiftKey && event.key === KeyboardEventKeys.TAB && document.activeElement === focusableElements[0]) {
      event.preventDefault();
      lastFocusableElement.focus();
    }
  };
  var handleFocusOnModalClose = function handleFocusOnModalClose() {
    if (isNotEmpty(elementWhichOpenedModal) && elementWhichOpenedModal !== document.body) {
      elementWhichOpenedModal.focus();
    }
  };
  return {
    handleKeyDown: handleKeyDown,
    handleFocusOnModalClose: handleFocusOnModalClose
  };
};
export default useModalFocus;